var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"affiliates-banner"},[_c('div',{staticClass:"banner-icons"}),_c('div',{staticClass:"banner-text"},[_vm._v("REFER YOUR FRIENDS AND EARN INCREDIBLE REWARDS WHEN THEY SIGN UP!")])])
}]

export { render, staticRenderFns }